/* ------------------------------------------------------------------ */
/*  global window typings (one-time)                                   */
declare global {
  interface Window {
    /* expose helpers so the popup can call them */
    connectVideoStreamWithDetection?: (
      videoElementId: string,
      cameraId: string
    ) => WebSocket;
    selectPersonId?: (personId: string) => void;
  }
}
export {}; // make this file a module

/* ------------------------------------------------------------------ */
/* 1.  PUBLIC – open WS + stream JPEG + control messages               */
let infoReady = false;

export function connectVideoStreamWithDetection(
  videoElementId: string,
  cameraId: string
): WebSocket {
  const ws = new WebSocket(
    `ws://localhost:8000/ws/video_with_detection/${cameraId}`
  );
  ws.binaryType = "arraybuffer";

  ws.onmessage = (evt) => {
    if (typeof evt.data === "string") {
      try {
        const msg = JSON.parse(evt.data);
        if (msg.person_ids) updatePersonSelectDropdown(msg.person_ids, ws);
      } catch (err) {
        console.error("WS JSON parse error:", err);
      }
      return;
    }

    const img = document.getElementById(videoElementId) as HTMLImageElement;
    if (img) {
      const blob = new Blob([evt.data], { type: "image/jpeg" });
      img.src = URL.createObjectURL(blob);
      updateFrame(blob);
    }
  };

  ws.onerror = (e) => console.error("Detection WS error:", e);
  ws.onclose = () => console.log("Detection WS closed");

  // Make selectPersonId and infoReady globally visible
  window.selectPersonId = function (pid) {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket not open. Cannot send selection.");
      return;
    }

    console.log("Sending selected_person_id:", pid);
    infoReady = false;
    ws.send(
      JSON.stringify({
        selected_person_id: pid ? +pid : null,
      })
    );

    // Wait 1 second to allow caching
    setTimeout(() => {
      infoReady = true;
    }, 1000);
  };

  window.infoReady = () => infoReady;

  return ws;
}

export function connectrealTimeVideoStreamWithDetection(
  videoElementId: string,
  cameraId: string
): WebSocket {
  const ws = new WebSocket(
    `ws://localhost:8000/ws/video_with_detection/${cameraId}`
  );
  ws.binaryType = "arraybuffer";

  ws.onmessage = (evt) => {
    if (typeof evt.data === "string") {
      try {
        const msg = JSON.parse(evt.data);
        if (msg.person_ids) updatePersonSelectDropdown(msg.person_ids, ws);
      } catch (err) {
        console.error("WS JSON parse error:", err);
      }
      return;
    }

    const img = document.getElementById(videoElementId) as HTMLImageElement;
    if (img) {
      const blob = new Blob([evt.data], { type: "image/jpeg" });
      img.src = URL.createObjectURL(blob);
      updateFrame(blob);
    }
  };

  ws.onerror = (e) => console.error("Detection WS error:", e);
  ws.onclose = () => console.log("Detection WS closed");

  // Make selectPersonId and infoReady globally visible
  window.selectPersonId = function (pid) {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket not open. Cannot send selection.");
      return;
    }

    console.log("Sending selected_person_id:", pid);
    infoReady = false;
    ws.send(
      JSON.stringify({
        selected_person_id: pid ? +pid : null,
      })
    );

    // Wait 1 second to allow caching
    setTimeout(() => {
      infoReady = true;
    }, 1000);
  };

  window.infoReady = () => infoReady;

  return ws;
}





/* 2.  dropdown helper ---------------------------------------------- */
let prevIds: number[] = [];

function updatePersonSelectDropdown(ids: number[], ws: WebSocket) {
  if (
    ids.length === prevIds.length &&
    ids.every((v, i) => v === prevIds[i])
  )
    return;
  prevIds = [...ids];

  const sel = document.getElementById(
    "person-select"
  ) as HTMLSelectElement;
  if (!sel) return;

  const keep = sel.value;
  sel.innerHTML = ""; // clear

  sel.appendChild(new Option("Show all", ""));

  ids.forEach((id) =>
    sel.appendChild(new Option(`Person ${id}`, id.toString()))
  );

  sel.value = ids.includes(+keep) ? keep : "";

  if (!sel.dataset.listenerAttached) {
    sel.addEventListener("change", () => {
      console.log("Dropdown changed to:", sel.value);
      window.selectPersonId?.(sel.value);
    });
    sel.dataset.listenerAttached = "true";
  }

}

/* 3.  “Identify” frame helpers ------------------------------------- */
let latestFrame: string | null = null;
let identifyClicked = false;

export function flagForIdentifyCapture() {
  identifyClicked = true;
}

export function updateFrame(blob: Blob) {
  if (!identifyClicked) return;

  const reader = new FileReader();
  reader.onloadend = () => {
    latestFrame = reader.result as string;
    identifyClicked = false;
  };
  reader.readAsDataURL(blob);
}

export function getLatestFrame(): string | null {
  return latestFrame;
}

/* 4.  plain MJPEG feed (home screen) ------------------------------- */
export function connectWebSocket(
  cameraId: string,
  updateVideo: (url: string) => void
): WebSocket {
  const ws = new WebSocket(
    `ws://localhost:8000/ws/video/${cameraId}`
  );
  ws.binaryType = "arraybuffer";

  ws.onmessage = (e) => {
    const url = URL.createObjectURL(
      new Blob([e.data], { type: "image/jpeg" })
    );
    updateVideo(url);
  };

  ws.onerror = (err) => console.error("Home WS error:", err);
  ws.onclose = () => console.log("Home WS closed");

  return ws;
}

/* expose for popup windows ----------------------------------------- */
window.connectVideoStreamWithDetection = connectVideoStreamWithDetection;
